import { Injectable } from "@angular/core";
import { IndexDbCacheService } from "../../../../services";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, map, switchMap } from 'rxjs/operators';
import { getErrorMessage } from "../../../../helpers";
import { CommonUtilService } from "../../../../services/CommonUtil.service";
import { Topology } from "topojson-specification";

@Injectable()
export class GeoChartJsonService {

  private readonly statesJsonPath: string = '/assets/json/states.json';
  private readonly statesKey: string = 'states';

  private readonly countriesJsonPath: string = '/assets/json/countries.json';
  private readonly countriesKey: string = 'countries';


  constructor(
    private indexDbCacheService: IndexDbCacheService,
    private http: HttpClient,
    private commonUtilService: CommonUtilService
  ) {
  }


  getCountriesObject(): Observable<Topology> {
    return this.getData(this.countriesJsonPath, this.countriesKey);
  }

  getStatesObject(): Observable<Topology> {
    return this.getData(this.statesJsonPath, this.statesKey)
  }

  private getData(url: string, key: string): Observable<Topology> {
    return this.indexDbCacheService.getData<Topology>(key).pipe(
      catchError(error => this.catchError(error)),
      switchMap((value: Topology) => {
        if (value) {
          return of(value);
        }
        return this.http.get<Topology>(url).pipe(
          switchMap((value: Topology) =>
            this.indexDbCacheService.setData<Topology>(key, value).pipe(
              catchError(error => this.catchError(error)),
              map(() => value)
            )
          )
        )
      }),
      catchError(error => this.catchError(error)),
    );
  }

  private catchError(error: any): Observable<any> {
    this.commonUtilService.showToastWithError(getErrorMessage(error));
    return of(null);
  }
}
